import { ref } from 'vue'
import { defineStore } from 'pinia'
import apiClient from '@/api/client'

/**
 * Evaluated feature flags for the current user, loaded once per session.
 * Unknown keys and load failures evaluate to FALSE — features ship dark
 * by default (same semantics as the backend).
 */
export const useFeaturesStore = defineStore('features', () => {
  const flags = ref<Record<string, boolean>>({})
  const loaded = ref(false)
  let inflight: Promise<void> | null = null

  // Concurrent callers (sidebar, router guard, dashboard) share one fetch.
  function load(): Promise<void> {
    inflight ??= (async () => {
      try {
        const resp = await apiClient.get<Record<string, boolean>>('/features')
        flags.value = resp.data
      } catch {
        flags.value = {}
      } finally {
        loaded.value = true
        inflight = null
      }
    })()
    return inflight
  }

  function isEnabled(key: string): boolean {
    return flags.value[key] === true
  }

  return { flags, loaded, load, isEnabled }
})
